import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppModuleGlobalShared } from 'src/app/app.module.global';
import { CoreModule } from '../../core/core.module';
import { InformesService } from './informes.service';
import { NgModule } from '@angular/core';
import { InformesRoutingModule } from './informes-routing.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InformeBusquedaComponent } from './informebusqueda/informe-busqueda.component';
import { InformeExportacionesComponent } from './informeexportaciones/informe-exportaciones.component';
import { InformeImportacionesComponent } from './informeimportaciones/informe-importaciones.component';
import { InformeInspeccionesComponent } from './informeinspecciones/informe-inspecciones.component';
import { InformeInspeccionesExportacionComponent } from './informeinspeccionesexportacion/informe-inspeccionesexportacion.component';
import { InformesListComponent } from './informes-list.component';
import { InformeTasasComponent } from './informetasas/informe-tasas.component';
import { InformeTasasExportacionComponent } from './informetasasexportacion/informe-tasasexportacion.component';

@NgModule({
    declarations: [
        InformesListComponent,
        InformeImportacionesComponent,
        InformeExportacionesComponent,
        InformeTasasComponent,
        InformeTasasExportacionComponent,
        InformeInspeccionesComponent,
        InformeInspeccionesExportacionComponent,
        InformeBusquedaComponent,
    ],
    imports: [InformesRoutingModule, CoreModule, FormsModule, AppModuleGlobalShared, CommonModule, ReactiveFormsModule, AutoCompleteModule],

    providers: [InformesService],
})
export class InformesModule {}
